<script>

import { Overlay } from '../../'

export default {
    name: 'WeightedClose',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Weighted Close - Weighted average of high, low, and close',
                preset: {
                    name: 'Weighted Close',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1,
                        color: '#9e9e9e'
                    }
                }
            }
        },
        use_for() { return ['WeightedClose'] },
        calc() {
            return {
                props: {},
                conf: { renderer: 'Spline' },
                update: `
                    return (high[0] + low[0] + (close[0] * 2)) / 4
                `
            }
        }
    }
}
</script>
